import BarrierUtilService from "./BarrierUtilService";
const BarrierService = new BarrierUtilService();

export default {
  getLogs(params) {
    const api = "/api/log";
    return BarrierService.get(api, { params });
  },
  getHumanLogs(params) {
    const api = "/api/log/human";
    return BarrierService.get(api, { params });
  },

  getFilterLogData() {
    const api = "/api/log/filter-data";
    return BarrierService.get(api);
  },

  getCameras(params) {
    const api = "/api/camera";
    return BarrierService.get(api, { params });
  },

  deleteCamera(id) {
    const api = `api/camera/${id}`;
    return BarrierService.delete(api);
  },

  updateCamera(id, data) {
    const api = `api/camera/${id}`;
    return BarrierService.put(api, data);
  },

  createCamera(data) {
    const api = "api/camera";
    return BarrierService.post(api, data);
  },

  getStations() {
    const api = "api/station";
    return BarrierService.get(api);
  },

  getGateByStationId(params) {
    const api = "api/gate";
    return BarrierService.get(api, { params });
  },

  getListGate(params){
    const api = "api/gate/find";
    return BarrierService.get(api, { params });
  },
  createGate(data) {
    const api = "api/gate";
    return BarrierService.post(api, data);
  },
  updateGate(id, data) {
    data.id = id;
    const api = `api/gate`;
    return BarrierService.put(api, data);
  },
  deleteGate(id) {
    const api = `api/gate/${id}`;
    return BarrierService.delete(api);
  },

  getDashboardData(stationId, date) {
    const api = `api/report/dashboard?station_id=${stationId}&date=${date}`;
    return BarrierService.get(api);
  },

  getFilterDashboardData() {
    const api = `api/report/dashboard/filter-data`;
    return BarrierService.get(api);
  },
};
